module.exports = __webpack_public_path__ + "img/bg01_1_zhCn.260ca896.png";